import React from 'react';

const EmailShareButton = ({ subject, body, to }) => {
  const handleClick = () => {
    const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <button onClick={handleClick}>
      <img
        src={process.env.NEXT_PUBLIC_WEPRODIGI + '/uploads/images/blog/email.svg'} width={26}
        height={26} alt="share email" />
    </button>
  );
};

export default EmailShareButton;
